import React, {useRef, useState} from 'react';
import {SelectInput, Title} from "react-admin";
import CardContent from "@material-ui/core/CardContent";
import {ReportForm, schoolYears} from "../../components";
import Grid from "@material-ui/core/Grid";
import moment from "moment/moment";
import env from "../../env";
import {downloadFilePost} from "../../components/FileDownload";

const ProductExemptionReport = () => {
    const ref = useRef({
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        schoolYear: schoolYears[0]?.id
    })

    const [loading, setLoading] = useState(false)
    const excelReport = () => {
        const {schoolYear} = ref.current
        setLoading(true)
        downloadFilePost(`${env.reportURL}/reports/bc-ds-hs-mien-giam?schoolYearId=${schoolYear}`, 'ds_hs_mien_giam.xlsx')
            .finally(() => {
                setLoading(false)
            })
    }

    return <div>
        <Title title="resources.bc-ds-hs-mien-giam.name"/>
        <CardContent>
            <ReportForm params={ref.current}
                        excelReport={excelReport}
                        isLoading={loading}
            >
                <p>Dữ liệu theo cấu hình "Miễn giảm học sinh"</p>
                <Grid container spacing={8}>
                    <Grid item xs={12} sm={6}>
                        <SelectInput label="resources.schoolYears.name" source="schoolYear" choices={schoolYears}/>
                    </Grid>
                </Grid>
            </ReportForm>
        </CardContent>
    </div>
}

export default ProductExemptionReport;
